<div class="app-modal-title">
	<i class="glyphicons glyphicons-alert"></i>
	Are you sure you want to proceed?
</div>
<div class="app-modal-content">
	<div class="warning-messages">
		<div *ngIf="data.noNguid.layers.length" class="msg-container">
			<div><span>{{data.noNguid.sq}}. </span>Without NGUID, the resulting QC report cannot be joined back to your source dataset.</div>
			<div class="msg-line">Layers that are missing NGUID: </div>
			<div *ngFor="let l of data.noNguid.layers" class="msg-line">{{l.name}}</div>
		</div>
		<div *ngIf="data.unMapped.layers.length" class="msg-container">
			<div><span>{{data.unMapped.sq}}. </span>Columns that are not mapped: </div>
			<div *ngFor="let l of data.unMapped.layers" class="msg-line">
				<div>{{l.name}}: </div>
				<div *ngFor="let col of l.cols" class="msg-line">{{col.colName}} </div>
			</div>
		</div>
		<div *ngIf="data.unMappedFishbone.layers.length" class="msg-container">
			<div><span>{{data.unMappedFishbone.sq}}. </span>Fishbone Columns that are not mapped: </div>
			<div *ngFor="let l of data.unMappedFishbone.layers" class="msg-line">
				<div>{{l.name}}: </div>
				<div *ngFor="let col of l.cols" class="msg-line">{{col.colName}} </div>
			</div>
		</div>
	</div>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" md-raised-button (click)="dialogRef.close(false)">Cancel</button>
		<button class="button-general" md-raised-button (click)="dialogRef.close(true)">Yes</button>
	</div>
</div>
